import * as z from "zod";
//#region src/__generated__/project-gge/projectGanttController/zod/ganttModelIdsDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const ganttModelIdsDtoSchema = z.object({
	ids: z.array(z.uuid()),
	projectId: z.uuid()
});
//#endregion
//#region src/__generated__/project-gge/projectGanttController/zod/primaryModelDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const primaryModelDtoSchema = z.object({
	id: z.uuid(),
	modelId: z.uuid(),
	projectId: z.uuid()
}).describe("Primary model of project.");
//#endregion
//#region src/__generated__/project-gge/projectGanttController/zod/addGanttModelsToProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const addGanttModelsToProjectStatus200Schema = z.array(primaryModelDtoSchema);
const addGanttModelsToProjectResponseSchema = addGanttModelsToProjectStatus200Schema;
const addGanttModelsToProjectDataSchema = ganttModelIdsDtoSchema;
//#endregion
//#region src/__generated__/project-gge/projectGanttController/zod/deleteGanttModelsToProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteGanttModelsToProjectStatus200Schema = z.unknown();
const deleteGanttModelsToProjectResponseSchema = deleteGanttModelsToProjectStatus200Schema;
const deleteGanttModelsToProjectDataSchema = ganttModelIdsDtoSchema;
//#endregion
//#region src/__generated__/project-gge/projectGanttController/zod/getGanttModelsByProjectIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getGanttModelsByProjectIdPathProjectIdSchema = z.uuid();
const getGanttModelsByProjectIdStatus200Schema = z.array(primaryModelDtoSchema);
const getGanttModelsByProjectIdResponseSchema = getGanttModelsByProjectIdStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/projectGanttController/zod/updateGanttModelSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateGanttModelPathModelIdSchema = z.uuid();
const updateGanttModelQueryNewModelIdSchema = z.uuid();
const updateGanttModelQueryProjectIdSchema = z.uuid();
const updateGanttModelStatus200Schema = z.unknown();
const updateGanttModelResponseSchema = updateGanttModelStatus200Schema;
//#endregion
export { updateGanttModelStatus200Schema as a, getGanttModelsByProjectIdStatus200Schema as c, deleteGanttModelsToProjectStatus200Schema as d, addGanttModelsToProjectDataSchema as f, ganttModelIdsDtoSchema as g, primaryModelDtoSchema as h, updateGanttModelResponseSchema as i, deleteGanttModelsToProjectDataSchema as l, addGanttModelsToProjectStatus200Schema as m, updateGanttModelQueryNewModelIdSchema as n, getGanttModelsByProjectIdPathProjectIdSchema as o, addGanttModelsToProjectResponseSchema as p, updateGanttModelQueryProjectIdSchema as r, getGanttModelsByProjectIdResponseSchema as s, updateGanttModelPathModelIdSchema as t, deleteGanttModelsToProjectResponseSchema as u };

//# sourceMappingURL=updateGanttModelSchema2.js.map